import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import "./css/BenefitMaxSchedule.css";
import useBenefitMaxSchedule from "./hooks/useBenefitMaxSchedule";

const BenefitMaxSchedule = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectModeParamData,
  onNavigate,
}) => {
  const benefitMaxScheduleData = useBenefitMaxSchedule(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectModeParamData,
    onNavigate
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={benefitMaxScheduleData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {benefitMaxScheduleData.screen_title} -{" "}
          <span className="heading-cod">
            {benefitMaxScheduleData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={benefitMaxScheduleData.formFields}
        dropdownValues={benefitMaxScheduleData.dropdownValues}
        paramsData={benefitMaxScheduleData.paramsData}
        updataParamData={benefitMaxScheduleData.updateParamData}
        disabledDropdowns={benefitMaxScheduleData.disabledDropdowns}
      />
      <ButtonsSection ctaButtons={benefitMaxScheduleData.ctaButtons} />
      <DisplayTable
        selectMode={benefitMaxScheduleData.selectMode}
        data={benefitMaxScheduleData.data}
        parmKey={benefitMaxScheduleData.parmKey}
        menuOptions={benefitMaxScheduleData.menuOptions}
        tableHeaders={benefitMaxScheduleData.columnDef}
        setRowData={benefitMaxScheduleData.setRowData}
        selectedPriceSchedules={benefitMaxScheduleData.selectedRows}
        setSelectedPriceSchedules={benefitMaxScheduleData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={benefitMaxScheduleData.first}
          rows={benefitMaxScheduleData.rows}
          totalRecords={benefitMaxScheduleData.totalRecords}
          currentPage={benefitMaxScheduleData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={benefitMaxScheduleData.onPageChange}
        />
      </div>
      {benefitMaxScheduleData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={benefitMaxScheduleData.isConfirmationModalOpen}
          onRequestClose={benefitMaxScheduleData.closeConfirmationModal}
          onBack={benefitMaxScheduleData.closeConfirmationModal}
          onSave={benefitMaxScheduleData.deleteBenefitMaxSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={benefitMaxScheduleData.setSelectedOption}
        />
      )}
      {benefitMaxScheduleData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={benefitMaxScheduleData.isHideConfirmationModalOpen}
          onRequestClose={benefitMaxScheduleData.closeHideConfirmationModal}
          onBack={benefitMaxScheduleData.closeHideConfirmationModal}
          onSave={benefitMaxScheduleData.hideBenefitMaxSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={benefitMaxScheduleData.setHideSelectedOption}
        />
      )}
      {benefitMaxScheduleData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={benefitMaxScheduleData.isHideConfirmationModalOpen}
          onRequestClose={benefitMaxScheduleData.closeHideConfirmationModal}
          onBack={benefitMaxScheduleData.closeHideConfirmationModal}
          onSave={benefitMaxScheduleData.hideBenefitMaxSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={benefitMaxScheduleData.setHideSelectedOption}
        />
      )}
    </div>
  );
};

export default BenefitMaxSchedule;
